import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {ITablePrice} from "../../ITablePrice";
import {ILabels} from "../../../../../../interfaces/ILabels";
import {Yii} from "../../../../../../interfaces/Yii";
import {
    faAngleDown,
    faAngleUp, faCircle,
    faCreditCard,
    faQuestion,
    faTags,
    IconDefinition
} from "@fortawesome/free-solid-svg-icons";
import {IVehicleRentalPriceColsHeaders, IVehicleRentalPriceRow} from "./interfaces/vehicle-rental-price-intefaces";
import {makeModel} from "../../../../../../service/utils/utils.service";
import {CarModel} from "../../../../../../models/car/car.model";

const COLS: string[] = [
    'title', 'total'
];

@Component({
    selector: 'vehicle-rental-price-tab',
    templateUrl: './vehicle-rental-price-tab.html',
    styleUrls: ['../stay-price-tab/stay-price-tab.component.scss'],
})
export class VehicleRentalPriceTabComponent implements OnInit {
    @Input()
    public prices?: ITablePrice;

    @Input()
    public isVehicleRentalBooking: boolean;

    @Input()
    public dataSourceTotal: IVehicleRentalPriceRow[];

    @Input()
    public colsHeader: IVehicleRentalPriceColsHeaders;

    @Input()
    public dataSourceDetails: IVehicleRentalPriceRow[];

    @Input()
    public bookingExtraData: any;

    public cols: string[] = COLS;

    public readonly iconCreditCard: IconDefinition = faCreditCard;
    public readonly iconAngleDown: IconDefinition = faAngleDown;
    public readonly iconAngleUp: IconDefinition = faAngleUp;
    public readonly iconTags: IconDefinition = faTags;
    public readonly iconQuestion: IconDefinition = faQuestion;
    public readonly iconCircle: IconDefinition = faCircle;

    public collapsed: { [key: string]: boolean } = {
        total: false,
        detail: false,
    };

    public vehicleRentalBookingModel: CarModel = null;
    public readonly wording: ILabels = {
        total: Yii.t('wui-shared-js', 'TOTAL'),
    };

    public ngOnInit(): void {
        this.initVehicleRentalBookingModel();
    }

    private initVehicleRentalBookingModel(): void {
        this.vehicleRentalBookingModel = makeModel(this.bookingExtraData, CarModel);
    }

    public collapse(row: IVehicleRentalPriceRow): void {
        if (row.collapser) {
            this.collapsed[row.collapser] = !this.collapsed[row.collapser];
        }
    }
}
